import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import addCode from "./components/add.vue";
export default {
  name: "serverList",
  components: {
    addCode: addCode
  },
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      advchannels: [],
      advLocation: [],
      pramas: {
        page: 1,
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      pramasMark: {
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      total: 0,
      list: []
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    gamechange: function gamechange(id) {
      searchplatform({
        game_id: id
      }).then(function (res) {});
    },
    platformchange: function platformchange(id) {
      searchchannel({
        platform_id: id
      }).then(function (res) {});
    },
    channelchange: function channelchange(id) {
      searchpkg({
        channel_id: id
      }).then(function (res) {});
    },
    pkgchange: function pkgchange(id) {},
    // 新增弹窗
    dialogShow: function dialogShow() {
      this.dialog = true;
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pramas.page = val;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      this.page = this.searchMark.pag;
      getLoginLists(this.searchMark).then(function (res) {
        _this2.tableData = res.data.data;
        _this2.total = res.data.total;
      });
    },
    // 删除配置
    deleHandle: function deleHandle(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLginConfig({
                  id: id
                }).then(function (res) {
                  _this3.getList();

                  _this3.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};